import React from 'react'
import './css/Caroseul.css'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"

import { BrowserRouter, Link } from "react-router-dom";
import './Demo.jsx'
// import Demo from './Demo.jsx';
export default function Caros() {
  return (
    <div>
        <main className="container">
  <div className="cover-container">
    {/* Cover Story */}
    <Link to="/oliver-johnson" id='link1'>
    <section className="cover-story">
      
      <img src="./images/Oliver-Johnson.jpg" alt="Oliver-johnson" />
      
      <div className="cover-content">
        
        <h1>Oliver Johnson</h1>
        
        <h2>Founder | LoomCraft Heritage</h2>
        {/* <p>
          Redefining Workplace Well-being and Human Potential with Visionary
          Innovation
        </p> */}
       
      </div>
    </section>
    </Link>
    {/* Featured Section */}
    <section className="featured-section">
      <article className="featured-card">
        <Link to="/fernando-perez">
        <img src="./images/Fernando-perez.jpg" alt="Fernando-perez" />
        </Link>
        <div className="card-content">
          <Link to="/fernando-perez" className='anchor'>
          <h3>Fernando Perez</h3>
          <p>Founder, Pérez & Sons Construction</p>
          </Link>
        </div>
      </article>
      <article className="featured-card">
        <Link to="/susan-brown">
        <img src="./images/Susan-brown.jpg" alt="Susan Brown" />
        </Link>
       
        <div className="card-content">
          <Link to="/susan-brown" className='anchor'>
          <h3>Susan Brown</h3>
          <p>CFO, Zing Foods and Produce
          </p>
          </Link> 
        </div>
      </article>
    </section>
  </div>
  <div className="carosel-container">
    <div id="carouselExampleCaptions" className="carousel slide"
    data-bs-ride="carousel"// Added this to enable automatic sliding
    data-bs-interval="2500" >{/* Added this to set the interval to 2.5 second */}
       
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to={0}
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        />
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to={1}
          aria-label="Slide 2"
        />
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to={2}
          aria-label="Slide 3"
        />
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <a href="#" className='caro-image'>
          <img
            src="./images/magazine.jpg"
            className="d-block w-100"
            id="carimg1"
            alt="..."
          />
          </a>
          {/* <div className="carousel-caption d-none d-md-block">
            <a href="#">
            <h5>First slide label</h5>
            <p>Some representative placeholder content for the first slide.</p>
            </a>
          </div> */}
        </div>
        <div className="carousel-item">
          <a href="">
          <img
          
            src="./images/magazine.jpg"
            className="d-block w-100"
            id="carimg2"
            alt="..."
          />
          </a>
          {/* <div className="carousel-caption d-none d-md-block">
            <a href="#">
            <h5>Second slide label</h5>
            </a>
            <a href="#">
            <p>Some representative placeholder content for the second slide.</p>
            </a>
          </div> */}
          
        </div>
        <div className="carousel-item">
            <a href="#" className='caro-image'>
          <img
            src="./images/magazine.jpg"
            className="d-block w-100"
            id="carimg3"
            alt="..."
          />
          </a>
          {/* <div className="carousel-caption d-none d-md-block">
            <a href="#">
            <h5>Third slide label </h5>
            <p> placeholder content for the third slide.</p>
            </a>
          </div> */}
        </div>
       
      </div>
      
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</main>




    </div>
  )
}
